import { useState, useEffect, useRef } from "react";

const FONTS = `@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;0,900;1,400&family=Figtree:wght@300;400;500;600;700&display=swap');`;

const CSS = `
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
html{scroll-behavior:smooth}
:root{
  --bg:#05080f;--surface:#0b1120;--surface2:#111827;--surface3:#0d1f3c;
  --border:rgba(255,255,255,.07);--border2:rgba(255,255,255,.13);
  --blue:#2563eb;--blue-l:#3b82f6;--blue-xl:#93c5fd;
  --cyan:#06b6d4;--gold:#f59e0b;--gold-l:#fcd34d;
  --green:#10b981;--purple:#8b5cf6;--pink:#ec4899;
  --white:#fff;--muted:rgba(255,255,255,.52);--muted2:rgba(255,255,255,.26);
  --head:'Playfair Display',serif;--body:'Figtree',sans-serif;
}
body{font-family:var(--body);background:var(--bg);color:var(--white);overflow-x:hidden;line-height:1.6}

/* NAV */
.nav{position:fixed;top:0;left:0;right:0;z-index:200;padding:1.4rem 0;transition:all .35s}
.nav.scrolled{background:rgba(5,8,15,.96);backdrop-filter:blur(20px);border-bottom:1px solid var(--border);padding:.85rem 0}
.nav-inner{display:flex;align-items:center;justify-content:space-between;max-width:1280px;margin:0 auto;padding:0 2.5rem}
.nav-logo{font-family:var(--head);font-size:1.5rem;font-weight:900;color:var(--white);letter-spacing:-.02em;cursor:pointer;background:none;border:none;line-height:1}
.nav-logo span{color:var(--blue-l)}
.nav-tagline{font-size:.58rem;letter-spacing:.1em;text-transform:uppercase;color:var(--muted2);margin-top:.15rem;font-weight:500}
.nav-links{display:flex;gap:2rem;align-items:center}
.nav-link{font-size:.84rem;font-weight:500;color:var(--muted);background:none;border:none;font-family:var(--body);cursor:pointer;transition:color .2s;letter-spacing:.03em;padding:0}
.nav-link:hover{color:var(--white)}
.nav-drop{position:relative}
.nav-drop-menu{position:absolute;top:calc(100% + .6rem);left:0;background:var(--surface);border:1px solid var(--border2);border-radius:6px;min-width:200px;padding:.5rem 0;opacity:0;pointer-events:none;transform:translateY(8px);transition:all .22s;z-index:20;box-shadow:0 16px 48px rgba(0,0,0,.5)}
.nav-drop:hover .nav-drop-menu{opacity:1;pointer-events:all;transform:translateY(0)}
.nav-drop-item{display:block;padding:.65rem 1.2rem;font-size:.82rem;color:var(--muted);cursor:pointer;background:none;border:none;font-family:var(--body);width:100%;text-align:left;transition:color .2s}
.nav-drop-item:hover{color:var(--white);background:rgba(255,255,255,.05)}
.nav-cta{display:flex;gap:.75rem;align-items:center}
.btn{display:inline-flex;align-items:center;justify-content:center;gap:.5rem;padding:.75rem 1.8rem;font-size:.9rem;font-weight:600;border-radius:4px;border:2px solid transparent;transition:all .25s;cursor:pointer;font-family:var(--body);letter-spacing:.02em;text-decoration:none}
.btn-primary{background:var(--blue);border-color:var(--blue);color:#fff}
.btn-primary:hover{background:var(--blue-l);border-color:var(--blue-l);transform:translateY(-2px)}
.btn-outline{background:none;border-color:rgba(255,255,255,.22);color:var(--white)}
.btn-outline:hover{border-color:rgba(255,255,255,.5);transform:translateY(-2px)}
.btn-gold{background:var(--gold);border-color:var(--gold);color:#000;font-weight:700}
.btn-gold:hover{background:#fbbf24;transform:translateY(-2px)}
.btn-green{background:var(--green);border-color:var(--green);color:#fff}
.btn-green:hover{background:#059669;transform:translateY(-2px)}
.btn-lg{padding:.95rem 2.4rem;font-size:1rem}
.btn-sm{padding:.5rem 1.2rem;font-size:.82rem}

/* HAMBURGER */
.hamburger{display:none;background:none;border:1.5px solid var(--border2);color:var(--white);width:38px;height:38px;border-radius:4px;cursor:pointer;flex-direction:column;align-items:center;justify-content:center;gap:5px}
.hamburger span{display:block;width:18px;height:2px;background:var(--white);border-radius:2px;transition:all .3s}
.hamburger.open span:nth-child(1){transform:translateY(7px) rotate(45deg)}
.hamburger.open span:nth-child(2){opacity:0}
.hamburger.open span:nth-child(3){transform:translateY(-7px) rotate(-45deg)}
.mob-menu{display:none;position:fixed;inset:0;z-index:190;background:var(--bg);padding:5.5rem 2rem 2rem;overflow-y:auto;flex-direction:column}
.mob-menu.open{display:flex}
.mob-section{font-size:.62rem;letter-spacing:.14em;text-transform:uppercase;color:var(--muted2);padding:.8rem 0 .3rem;font-weight:700}
.mob-link{display:block;font-size:1.05rem;font-weight:500;color:var(--muted);padding:.85rem 0;border-bottom:1px solid var(--border);background:none;border-left:none;border-right:none;border-top:none;font-family:var(--body);cursor:pointer;text-align:left;width:100%;transition:color .2s}
.mob-link:hover{color:var(--white)}
.mob-ctas{display:flex;flex-direction:column;gap:.75rem;margin-top:1.5rem}

/* COMMON */
.section-tag{font-size:.68rem;letter-spacing:.14em;text-transform:uppercase;color:var(--blue-l);font-weight:700;margin-bottom:1rem;display:flex;align-items:center;gap:.6rem}
.section-tag::before{content:'';width:2rem;height:1px;background:var(--blue-l)}
.section-tag.gold{color:var(--gold-l)}.section-tag.gold::before{background:var(--gold-l)}
.section-tag.green{color:var(--green)}.section-tag.green::before{background:var(--green)}
.section-tag.pink{color:var(--pink)}.section-tag.pink::before{background:var(--pink)}
.section-h{font-family:var(--head);font-size:clamp(2rem,3.5vw,3.2rem);font-weight:900;letter-spacing:-.025em;line-height:1.08;margin-bottom:1.2rem}
.section-p{font-size:1rem;line-height:1.78;color:var(--muted);font-weight:300;max-width:560px}
.container{max-width:1200px;margin:0 auto;padding:0 2rem}

/* HERO */
.hero{min-height:100vh;display:flex;align-items:center;padding:10rem 0 6rem;position:relative;overflow:hidden}
.hero-bg{position:absolute;inset:0;z-index:0;background:radial-gradient(ellipse 70% 60% at 50% -5%,rgba(37,99,235,.22) 0%,transparent 65%),radial-gradient(ellipse 35% 40% at 90% 90%,rgba(6,182,212,.08) 0%,transparent 60%),radial-gradient(ellipse 25% 30% at 5% 80%,rgba(139,92,246,.07) 0%,transparent 60%),var(--bg)}
.hero-grid{position:absolute;inset:0;z-index:0;opacity:.028;background-image:linear-gradient(rgba(255,255,255,.9) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.9) 1px,transparent 1px);background-size:60px 60px}
.hero-content{position:relative;z-index:1;max-width:1280px;margin:0 auto;padding:0 2.5rem;display:grid;grid-template-columns:1.1fr .9fr;gap:5rem;align-items:center}
.hero-pill{display:inline-flex;align-items:center;gap:.6rem;border:1px solid rgba(37,99,235,.4);background:rgba(37,99,235,.08);padding:.35rem 1rem;border-radius:100px;font-size:.73rem;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:var(--blue-l);margin-bottom:2rem}
.hero-dot{width:6px;height:6px;border-radius:50%;background:var(--cyan);animation:blink 2s infinite;flex-shrink:0}
@keyframes blink{0%,100%{opacity:1}50%{opacity:.3}}
.hero-h1{font-family:var(--head);font-size:clamp(2.8rem,5vw,5.2rem);line-height:1.03;letter-spacing:-.035em;margin-bottom:1rem;font-weight:900}
.hero-h1 em{font-style:italic;color:var(--blue-l)}
.hero-mission{font-size:.9rem;font-weight:700;letter-spacing:.06em;color:var(--gold);text-transform:uppercase;margin-bottom:1.2rem}
.hero-sub{font-size:1.05rem;line-height:1.8;color:var(--muted);font-weight:300;max-width:520px;margin-bottom:2.5rem}
.hero-actions{display:flex;gap:1rem;flex-wrap:wrap}
.hero-right{display:flex;flex-direction:column;gap:1.5rem}
.hero-card{background:var(--surface);border:1px solid var(--border2);border-radius:8px;padding:1.8rem;position:relative;overflow:hidden;transition:border-color .3s}
.hero-card:hover{border-color:rgba(37,99,235,.35)}
.hero-card-accent{position:absolute;top:0;left:0;right:0;height:3px}
.hero-card-icon{font-size:1.8rem;margin-bottom:.9rem}
.hero-card-title{font-family:var(--head);font-size:1rem;font-weight:700;margin-bottom:.5rem}
.hero-card-text{font-size:.83rem;line-height:1.65;color:var(--muted)}
.hero-scroll{position:absolute;bottom:2.5rem;left:50%;transform:translateX(-50%);z-index:1;display:flex;flex-direction:column;align-items:center;gap:.5rem;color:var(--muted2);font-size:.68rem;letter-spacing:.1em;text-transform:uppercase}
.scroll-line{width:1px;height:40px;background:linear-gradient(to bottom,var(--blue-l),transparent);animation:sd 2s infinite}
@keyframes sd{0%{opacity:0;transform:scaleY(0);transform-origin:top}50%{opacity:1}100%{opacity:0;transform:scaleY(1);transform-origin:bottom}}

/* MISSION */
.mission-band{background:linear-gradient(135deg,var(--surface3) 0%,var(--surface) 100%);border-top:1px solid var(--border);border-bottom:1px solid var(--border);padding:5rem 0}
.mission-inner{max-width:1280px;margin:0 auto;padding:0 2.5rem;display:grid;grid-template-columns:1fr 1fr;gap:6rem;align-items:center}
.mission-quote{font-family:var(--head);font-size:clamp(1.6rem,2.5vw,2.2rem);font-weight:700;line-height:1.3;font-style:italic;color:var(--white);margin-bottom:1.5rem}
.mission-attr{font-size:.8rem;letter-spacing:.12em;text-transform:uppercase;color:var(--gold);font-weight:600}
.mission-pillars{display:grid;grid-template-columns:1fr 1fr;gap:1.5px;background:var(--border)}
.mission-pillar{background:var(--surface);padding:1.8rem 1.5rem}
.mission-pillar-icon{font-size:1.5rem;margin-bottom:.75rem}
.mission-pillar-title{font-weight:700;font-size:.92rem;margin-bottom:.4rem}
.mission-pillar-text{font-size:.81rem;line-height:1.6;color:var(--muted)}

/* TWO PILLARS */
.pillars-section{padding:7rem 0;background:var(--bg)}
.pillars-header{text-align:center;margin-bottom:4rem}
.pillars-header .section-p{margin:0 auto}
.pillars-grid{display:grid;grid-template-columns:1fr 1fr;gap:1.5px;background:var(--border)}
.pillar-panel{padding:5rem 4rem;position:relative;overflow:hidden}
.pillar-panel.awareness{background:var(--surface)}
.pillar-panel.coaching{background:var(--surface2)}
.pillar-num{font-family:var(--head);font-size:9rem;font-weight:900;position:absolute;top:1rem;right:2rem;color:rgba(255,255,255,.025);line-height:1;pointer-events:none;user-select:none}
.pillar-items{display:flex;flex-direction:column;gap:1.2rem;margin-top:2.5rem}
.pillar-item{border-left:2px solid var(--border);padding:.7rem 0 .7rem 1.4rem;transition:border-color .25s}
.pillar-item:hover{border-left-color:var(--blue-l)}
.pillar-item-title{font-weight:600;font-size:.93rem;margin-bottom:.25rem}
.pillar-item-text{font-size:.82rem;line-height:1.6;color:var(--muted)}

/* AUDIENCES */
.audience-section{background:var(--surface2);padding:7rem 0}
.audience-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:1.5px;background:var(--border);margin-top:3.5rem}
.aud-card{background:var(--surface2);padding:3rem 2.5rem;position:relative;overflow:hidden;transition:background .3s}
.aud-card::before{content:'';position:absolute;top:0;left:0;right:0;height:3px;transform:scaleX(0);transform-origin:left;transition:transform .35s}
.aud-card.young::before{background:linear-gradient(90deg,var(--blue),var(--cyan))}
.aud-card.exec::before{background:linear-gradient(90deg,var(--gold),#f97316)}
.aud-card.society::before{background:linear-gradient(90deg,var(--green),var(--cyan))}
.aud-card:hover{background:var(--surface)}
.aud-card:hover::before{transform:scaleX(1)}
.aud-icon{font-size:2.2rem;margin-bottom:1.5rem}
.aud-tag{font-size:.65rem;letter-spacing:.12em;text-transform:uppercase;font-weight:700;margin-bottom:.7rem}
.aud-tag.young{color:var(--blue-l)}.aud-tag.exec{color:var(--gold)}.aud-tag.society{color:var(--green)}
.aud-title{font-family:var(--head);font-size:1.3rem;font-weight:700;margin-bottom:.9rem;line-height:1.2}
.aud-text{font-size:.86rem;line-height:1.72;color:var(--muted);margin-bottom:1.8rem}
.aud-features{display:flex;flex-direction:column;gap:.5rem}
.aud-feature{font-size:.81rem;color:var(--muted);display:flex;align-items:center;gap:.6rem}
.aud-feature::before{content:'→';font-size:.72rem;flex-shrink:0}
.aud-feature.young::before{color:var(--blue-l)}.aud-feature.exec::before{color:var(--gold)}.aud-feature.society::before{color:var(--green)}

/* ASSESSMENT */
.assessment-section{background:linear-gradient(135deg,var(--surface) 0%,#0d1a35 100%);border-top:1px solid var(--border);border-bottom:1px solid var(--border)}
.assessment-inner{display:grid;grid-template-columns:1fr 1fr;gap:6rem;align-items:center;max-width:1280px;margin:0 auto;padding:6rem 2.5rem}
.assessment-badge{display:inline-flex;align-items:center;gap:.5rem;background:rgba(245,158,11,.1);border:1px solid rgba(245,158,11,.3);color:var(--gold);font-size:.72rem;font-weight:700;letter-spacing:.1em;text-transform:uppercase;padding:.3rem .9rem;border-radius:100px;margin-bottom:1.2rem}
.assessment-h{font-family:var(--head);font-size:clamp(1.8rem,3vw,2.8rem);font-weight:900;margin-bottom:1.2rem;line-height:1.1}
.assessment-p{font-size:.95rem;line-height:1.78;color:var(--muted);font-weight:300;margin-bottom:2rem}
.assessment-steps{display:flex;flex-direction:column;gap:1.2rem;margin-bottom:2.5rem}
.assessment-step{display:flex;align-items:flex-start;gap:1rem}
.step-num{width:32px;height:32px;border-radius:50%;background:rgba(37,99,235,.15);border:1px solid rgba(37,99,235,.3);color:var(--blue-l);font-size:.78rem;font-weight:700;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.step-body{font-size:.88rem;line-height:1.6;color:var(--muted);padding-top:.3rem}
.step-title{color:var(--white);font-weight:600;display:block;margin-bottom:.2rem}
.assess-visual{background:var(--surface2);border:1px solid var(--border);border-radius:8px;padding:2.5rem;position:relative;overflow:hidden}
.assess-glow{position:absolute;top:-40px;right:-40px;width:200px;height:200px;border-radius:50%;background:radial-gradient(circle,rgba(37,99,235,.3),transparent 70%);filter:blur(30px)}
.assess-score-lbl{font-size:.72rem;letter-spacing:.1em;text-transform:uppercase;color:var(--muted2);margin-bottom:.8rem}
.assess-score-num{font-family:var(--head);font-size:4rem;font-weight:900;color:var(--blue-l);line-height:1;margin-bottom:.5rem}
.assess-score-sub{font-size:.85rem;color:var(--muted);margin-bottom:2rem}
.assess-bars{display:flex;flex-direction:column;gap:.8rem}
.assess-bar-row{display:flex;flex-direction:column;gap:.3rem}
.assess-bar-lbl{display:flex;justify-content:space-between;font-size:.78rem;color:var(--muted)}
.assess-bar-track{height:6px;background:rgba(255,255,255,.07);border-radius:3px}
.assess-bar-fill{height:100%;border-radius:3px;background:linear-gradient(90deg,var(--blue),var(--cyan));transition:width 1.2s cubic-bezier(.4,0,.2,1)}

/* PROGRAMS */
.programs-section{padding:7rem 0;background:var(--bg)}
.programs-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:1.5px;background:var(--border);margin-top:3.5rem}
.prog-card{background:var(--bg);padding:2.8rem 2.5rem;position:relative;overflow:hidden;transition:background .3s}
.prog-card:hover{background:var(--surface)}
.prog-card::before{content:'';position:absolute;top:0;left:0;right:0;height:3px;transform:scaleX(0);transform-origin:left;transition:transform .35s}
.prog-card:hover::before{transform:scaleX(1)}
.prog-card.p1::before{background:linear-gradient(90deg,var(--blue),var(--cyan))}
.prog-card.p2::before{background:linear-gradient(90deg,var(--gold),#f97316)}
.prog-card.p3::before{background:linear-gradient(90deg,var(--green),var(--cyan))}
.prog-card.p4::before{background:linear-gradient(90deg,var(--purple),var(--blue-l))}
.prog-badge{display:inline-block;font-size:.62rem;font-weight:700;letter-spacing:.1em;text-transform:uppercase;padding:.2rem .65rem;border-radius:2px;margin-bottom:1.2rem}
.pb1{background:rgba(37,99,235,.15);color:var(--blue-xl)}
.pb2{background:rgba(245,158,11,.15);color:var(--gold)}
.pb3{background:rgba(16,185,129,.15);color:var(--green)}
.pb4{background:rgba(139,92,246,.15);color:#c4b5fd}
.prog-icon{font-size:1.8rem;margin-bottom:.9rem}
.prog-title{font-family:var(--head);font-size:1.2rem;font-weight:700;margin-bottom:.4rem;line-height:1.2}
.prog-audience{font-size:.76rem;color:var(--muted2);margin-bottom:.9rem;font-weight:500}
.prog-text{font-size:.86rem;line-height:1.7;color:var(--muted);margin-bottom:1.5rem}
.prog-details{display:flex;gap:1.5rem;flex-wrap:wrap}
.prog-detail strong{color:var(--white);font-weight:600;display:block;margin-bottom:.1rem;font-size:.78rem}
.prog-detail span{font-size:.78rem;color:var(--muted2)}

/* BLOG */
.blog-section{background:var(--surface);padding:7rem 0;border-top:1px solid var(--border)}
.blog-header{display:flex;align-items:flex-end;justify-content:space-between;margin-bottom:3rem;flex-wrap:wrap;gap:1.5rem}
.blog-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:1.5px;background:var(--border)}
.blog-card{background:var(--surface);overflow:hidden;transition:background .25s;display:flex;flex-direction:column;cursor:pointer}
.blog-card:hover{background:var(--surface2)}
.blog-card-img{height:190px;position:relative;display:flex;align-items:center;justify-content:center;font-size:3rem;overflow:hidden}
.blog-card-cat{position:absolute;top:1rem;left:1rem;font-size:.63rem;font-weight:700;letter-spacing:.08em;text-transform:uppercase;padding:.25rem .65rem;border-radius:2px}
.cat-dt{background:rgba(37,99,235,.25);color:var(--blue-xl);border:1px solid rgba(37,99,235,.3)}
.cat-ai{background:rgba(6,182,212,.2);color:#67e8f9;border:1px solid rgba(6,182,212,.25)}
.cat-eth{background:rgba(245,158,11,.15);color:#fcd34d;border:1px solid rgba(245,158,11,.25)}
.blog-card-body{padding:1.8rem;flex:1}
.blog-card-meta{font-size:.74rem;color:var(--muted2);margin-bottom:.7rem}
.blog-card-title{font-family:var(--head);font-size:1.05rem;font-weight:700;line-height:1.3;margin-bottom:.6rem;color:var(--white);transition:color .2s}
.blog-card:hover .blog-card-title{color:var(--blue-xl)}
.blog-card-excerpt{font-size:.82rem;line-height:1.65;color:var(--muted)}
.blog-card-footer{padding:1.1rem 1.8rem;border-top:1px solid var(--border);display:flex;justify-content:space-between;align-items:center}
.blog-read{font-size:.78rem;font-weight:600;color:var(--blue-l);display:inline-flex;align-items:center;gap:.35rem;transition:gap .2s}
.blog-card:hover .blog-read{gap:.6rem}
.blog-rt{font-size:.74rem;color:var(--muted2)}

/* MODAL */
.modal-overlay{position:fixed;inset:0;z-index:500;background:rgba(5,8,15,.92);backdrop-filter:blur(10px);display:flex;align-items:center;justify-content:center;padding:2rem;animation:fadeIn .22s ease}
@keyframes fadeIn{from{opacity:0}to{opacity:1}}
.modal-box{background:var(--surface);width:100%;max-width:800px;border-radius:10px;max-height:90vh;overflow-y:auto;border:1px solid var(--border2);animation:modalUp .28s ease}
@keyframes modalUp{from{transform:translateY(40px);opacity:0}to{transform:translateY(0);opacity:1}}
.modal-img{height:220px;position:relative;display:flex;align-items:center;justify-content:center;font-size:3.5rem;border-radius:10px 10px 0 0;overflow:hidden}
.modal-badge{position:absolute;top:1.2rem;left:1.5rem;font-size:.67rem;font-weight:700;letter-spacing:.08em;text-transform:uppercase;padding:.3rem .8rem;border-radius:2px}
.modal-close-x{position:absolute;top:1rem;right:1rem;background:rgba(0,0,0,.45);border:none;color:#fff;font-size:1.1rem;cursor:pointer;padding:.35rem .65rem;border-radius:4px;line-height:1;transition:background .2s}
.modal-close-x:hover{background:rgba(0,0,0,.75)}
.modal-body{padding:2.5rem 3rem}
.modal-meta{font-size:.77rem;color:var(--muted2);margin-bottom:1rem}
.modal-title{font-family:var(--head);font-size:1.7rem;font-weight:900;line-height:1.15;margin-bottom:1.5rem}
.modal-content{font-size:.95rem;line-height:1.85;color:var(--muted);font-weight:300}
.modal-content p{margin-bottom:1.2rem}
.modal-content h3{font-family:var(--head);color:var(--white);font-size:1.2rem;margin:2rem 0 .75rem}
.modal-content strong{color:var(--white);font-weight:600}
.modal-content ul{margin:.5rem 0 1.2rem 1.5rem;list-style:disc}
.modal-content li{margin-bottom:.4rem}
.modal-footer{padding:1.5rem 3rem;border-top:1px solid var(--border);display:flex;justify-content:space-between;align-items:center}

/* NEWSLETTER */
.nl-section{background:var(--surface2);border-top:1px solid var(--border);padding:7rem 0}
.nl-inner{display:grid;grid-template-columns:1fr 1fr;gap:7rem;align-items:center;max-width:1280px;margin:0 auto;padding:0 2.5rem}
.nl-perks{display:flex;flex-direction:column;gap:.8rem;margin-top:2rem}
.nl-perk{display:flex;align-items:center;gap:.75rem;font-size:.875rem;color:var(--muted)}
.nl-dot{width:5px;height:5px;border-radius:50%;background:var(--cyan);flex-shrink:0}
.nl-form{display:flex;flex-direction:column;gap:.9rem;margin-top:1rem}
.nl-form-title{font-family:var(--head);font-size:1.2rem;font-weight:700}
.nl-input,.nl-select{background:var(--surface);border:1.5px solid var(--border);color:var(--white);padding:.88rem 1.1rem;font-size:.9rem;font-family:var(--body);border-radius:4px;outline:none;transition:border-color .2s;width:100%}
.nl-input::placeholder{color:var(--muted2)}
.nl-input:focus,.nl-select:focus{border-color:var(--blue-l)}
.nl-select option{background:var(--surface2)}
.nl-disc{font-size:.73rem;color:var(--muted2)}

/* FOOTER */
.site-footer{background:var(--bg);border-top:1px solid var(--border);padding:5rem 0 2rem}
.footer-inner{max-width:1280px;margin:0 auto;padding:0 2.5rem}
.footer-grid{display:grid;grid-template-columns:2fr 1fr 1fr 1fr;gap:4rem;margin-bottom:4rem}
.footer-logo{font-family:var(--head);font-size:1.4rem;font-weight:900;margin-bottom:.3rem}
.footer-logo span{color:var(--blue-l)}
.footer-mission{font-size:.65rem;letter-spacing:.1em;text-transform:uppercase;color:var(--gold);font-weight:600;margin-bottom:.9rem}
.footer-tagline{font-size:.875rem;line-height:1.7;color:var(--muted);font-weight:300}
.footer-col-title{font-size:.65rem;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:var(--blue-l);margin-bottom:1.2rem}
.footer-links{display:flex;flex-direction:column;gap:.6rem}
.footer-link{font-size:.83rem;color:var(--muted);background:none;border:none;padding:0;text-align:left;cursor:pointer;transition:color .2s;font-family:var(--body)}
.footer-link:hover{color:var(--white)}
.footer-bottom{border-top:1px solid var(--border);padding-top:1.8rem;display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:1rem}
.footer-copy{font-size:.78rem;color:var(--muted2)}
.footer-socials{display:flex;gap:1.5rem}
.footer-social{font-size:.78rem;color:var(--muted2);cursor:pointer;transition:color .2s;background:none;border:none;font-family:var(--body)}
.footer-social:hover{color:var(--white)}

/* TOAST */
.toast{position:fixed;bottom:2rem;right:2rem;z-index:600;background:var(--blue);color:#fff;padding:1rem 1.5rem;border-radius:4px;font-size:.875rem;font-weight:500;box-shadow:0 8px 32px rgba(37,99,235,.4);opacity:0;pointer-events:none;transform:translateY(12px);transition:all .3s}
.toast.show{opacity:1;pointer-events:auto;transform:translateY(0)}

/* RESPONSIVE */
@media(max-width:1024px){
  .hero-content{grid-template-columns:1fr;text-align:center}
  .hero-right{display:none}
  .hero-actions{justify-content:center}
  .mission-inner{grid-template-columns:1fr;gap:3rem}
  .assessment-inner{grid-template-columns:1fr;gap:3rem}
  .nl-inner{grid-template-columns:1fr;gap:3rem}
  .footer-grid{grid-template-columns:1fr 1fr;gap:2.5rem}
  .programs-grid{grid-template-columns:1fr}
  .audience-grid{grid-template-columns:1fr 1fr}
  .pillars-grid{grid-template-columns:1fr}
}
@media(max-width:768px){
  .nav-links,.nav-cta{display:none}
  .hamburger{display:flex}
  .hero{padding:7rem 0 4rem}
  .hero-content{padding:0 1.5rem}
  .hero-actions{flex-direction:column;align-items:center}
  .hero-actions .btn{width:100%;max-width:300px}
  .audience-grid,.blog-grid{grid-template-columns:1fr}
  .pillar-panel{padding:3.5rem 1.5rem}
  .footer-grid{grid-template-columns:1fr;gap:2rem}
  .footer-bottom{flex-direction:column;align-items:flex-start}
  .container{padding:0 1.5rem}
  .section-h{font-size:clamp(1.7rem,6vw,2.4rem)}
  .toast{bottom:1rem;right:1rem;left:1rem;text-align:center}
  .nav-inner{padding:0 1.5rem}
  .mission-inner,.assessment-inner,.nl-inner{padding:0 1.5rem}
  .modal-body,.modal-footer{padding:1.5rem}
  .mission-pillars{grid-template-columns:1fr}
}
@media(max-width:400px){
  .hero-h1{font-size:2.4rem}
  .aud-card{padding:2rem 1.5rem}
  .prog-card{padding:2rem 1.5rem}
}
`;

const ASSESSMENT_URL = "http://74.208.201.3/";

const BLOGS = [
  { id:1, title:"From Pilot to Production: Accelerating Enterprise AI Implementation", url:"https://mentrum.ai/from-pilot-to-production-accelerating-enterprise-ai-implementation/", cat:"AI Strategy", catClass:"cat-dt", date:"October 13, 2025", rt:"8 min", emoji:"🏭", bg:"linear-gradient(135deg,#0b3d8c,#05080f)", excerpt:"Organizations often get stuck in the AI pilot trap — running proofs-of-concept that never make it into production. Here's how to bridge that gap systematically.", body:`<h3>The AI Pilot Trap</h3><p>Over <strong>70% of AI projects fail to make it to production</strong>. The reasons are consistent: lack of strategic alignment, data challenges, talent gaps, and cultural resistance.</p><h3>1. Start with a Clear Business Case</h3><p>Frame it as: <em>"Using predictive analytics to increase retention by 10% in six months"</em> — not "exploring machine learning." Clarity drives production.</p><h3>2. Build a Scalable Data Foundation</h3><p>Centralize data using lake or lakehouse architectures, ensure quality and governance, and automate pipelines. Data quality is the single most under-invested area in AI programs.</p><h3>3. Adopt an MLOps Framework</h3><p>Tools like <strong>MLflow</strong>, <strong>Kubeflow</strong>, and <strong>Vertex AI Pipelines</strong> automate the lifecycle — reducing time from pilot to production by up to 50%.</p><h3>4. Cross-Functional Collaboration</h3><p>Pair data scientists with domain experts, involve IT early, and get business leaders on board. AI projects that blend technical depth with business understanding move faster.</p><h3>5. Measure, Monitor, and Iterate</h3><p>Continuously monitor for performance, drift, and business impact. Feedback loops ensure your AI stays relevant and value-driven.</p>` },
  { id:2, title:"Infrastructure for Scale: Building a Robust AI Data Pipeline", url:"https://mentrum.ai/infrastructure-for-scale-building-a-robust-ai-data-pipeline/", cat:"Scaling with AI", catClass:"cat-ai", date:"October 13, 2025", rt:"11 min", emoji:"⚙️", bg:"linear-gradient(135deg,#0e4f5c,#05080f)", excerpt:"If AI is the engine, data is its fuel — and a robust AI data pipeline is the refinery that ensures the engine runs smoothly, efficiently, and at scale.", body:`<h3>Why Pipelines Matter</h3><p>A poorly designed pipeline leads to inconsistent data, deployment delays, and models that fail in real-world conditions. A well-architected pipeline ensures your AI always has access to <strong>accurate, timely, and relevant data</strong>.</p><h3>Core Components</h3><p><strong>Ingestion</strong> — Streaming platforms like Apache Kafka for real-time data. Batch ingestion for large datasets.</p><p><strong>Storage</strong> — Data Lakes for raw data, Data Warehouses for structured data, hybrid architectures for combined needs.</p><p><strong>Processing</strong> — Apache Spark or Databricks for distributed processing. Feature stores for reusable ML-ready data.</p><h3>Scaling the Infrastructure</h3><p>Containerization with Docker and Kubernetes, cloud-native architecture, and serverless processing transform AI from a <em>project</em> into a <em>platform</em>.</p>` },
  { id:3, title:"The Ethical Frontier: Navigating Bias in Generative AI", url:"https://mentrum.ai/the-ethical-frontier-navigating-bias-in-generative-ai/", cat:"AI Ethics", catClass:"cat-eth", date:"October 13, 2025", rt:"6 min", emoji:"⚖️", bg:"linear-gradient(135deg,#3d2a0b,#05080f)", excerpt:"As AI systems become more deeply integrated into daily life, the ethical implications of bias are no longer theoretical — they are personal, social, and global.", body:`<h3>Understanding Bias in AI</h3><p>Bias in AI reflects the data it's trained on. Since the internet mirrors human behavior, it contains stereotypes and cultural imbalances that seep into models.</p><h3>Who Is Responsible?</h3><p>Responsibility extends to developers, organizations, regulators, and users alike. Ethical AI requires a <strong>shared accountability framework</strong>.</p><h3>Navigating the Frontier</h3><p><strong>Transparency:</strong> AI systems should not be black boxes.</p><p><strong>Diverse Data:</strong> Training datasets should represent multiple demographics, cultures, and viewpoints.</p><p><strong>Bias Auditing:</strong> Regular audits and fairness metrics help identify and correct biases early.</p><p><strong>Human Oversight:</strong> AI should augment human judgment, not replace it. Every generation deserves AI that serves them fairly.</p>` },
];

const ASSESS_DIMS = [
  {label:"People & Culture",val:78},{label:"Data Foundation",val:65},{label:"Technology Stack",val:80},{label:"Process & Governance",val:68},
];

const PROGRAMS = [
  { cls:"p1", badge:"pb1", dur:"8 Weeks",    icon:"🎓", title:"Young AI Leaders",       audience:"Students & Early Career · Ages 16–25",  text:"An 8-week cohort program equipping the next generation with practical AI literacy, ethical reasoning, and the confidence to shape technology's future.", format:"Weekly live sessions", size:"Cohort of 15", price:"Free / Subsidized" },
  { cls:"p2", badge:"pb2", dur:"4 Weeks",    icon:"🌿", title:"AI Foundations for Life", audience:"Professionals 50+ & Retirees",            text:"A gentle, accessible program helping experienced professionals understand AI's impact on their careers, communities, and everyday lives — no technical background required.", format:"Online, self-paced", size:"Small groups", price:"Affordable" },
  { cls:"p3", badge:"pb3", dur:"6 Sessions", icon:"⚡", title:"Executive AI Readiness",   audience:"C-Suite & Board Leaders",               text:"Intensive 1:1 coaching preparing senior leaders to set AI strategy, govern responsibly, and drive adoption across their organizations.", format:"1:1 Coaching", size:"Individual", price:"Premium" },
  { cls:"p4", badge:"pb4", dur:"12 Weeks",   icon:"🔄", title:"AI Career Pivot",          audience:"Mid-Career Professionals",              text:"A comprehensive reskilling program for professionals seeking AI-adjacent roles — from AI project management to ethics and governance.", format:"Hybrid learning", size:"Cohort of 20", price:"Paid" },
];

export default function MentrumAI() {
  const [scrolled, setScrolled]       = useState(false);
  const [menuOpen, setMenuOpen]       = useState(false);
  const [activePost, setActivePost]   = useState(null);
  const [toast, setToast]             = useState(null);
  const [nlName, setNlName]           = useState("");
  const [nlEmail, setNlEmail]         = useState("");
  const [nlFreq, setNlFreq]           = useState("weekly");
  const [barsVisible, setBarsVisible] = useState(false);
  const assessRef  = useRef(null);
  const toastTimer = useRef(null);

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", h, { passive:true });
    return () => window.removeEventListener("scroll", h);
  }, []);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setBarsVisible(true); }, { threshold:0.3 });
    if (assessRef.current) obs.observe(assessRef.current);
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    const h = e => { if (e.key==="Escape") { setActivePost(null); setMenuOpen(false); document.body.style.overflow=""; } };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, []);

  const goTo = id => { setMenuOpen(false); document.body.style.overflow=""; setTimeout(()=>document.getElementById(id)?.scrollIntoView({behavior:"smooth",block:"start"}),50); };
  const toggleMenu = () => { const n=!menuOpen; setMenuOpen(n); document.body.style.overflow=n?"hidden":""; };
  const showToast = (msg,err) => { clearTimeout(toastTimer.current); setToast({msg,err}); toastTimer.current=setTimeout(()=>setToast(null),3500); };
  const subscribe = () => { if (!nlEmail.includes("@")) return showToast("Please enter a valid email.",true); showToast(`Subscribed! Welcome${nlName?", "+nlName:""} to the Mentrum AI Digest.`); setNlName(""); setNlEmail(""); };

  return (
    <>
      <style>{FONTS}{CSS}</style>

      {/* NAV */}
      <nav className={`nav${scrolled?" scrolled":""}`}>
        <div className="nav-inner">
          <div>
            <button className="nav-logo" onClick={()=>goTo("hero")}>mentrum<span>.</span>ai</button>
            <div className="nav-tagline">Mentors of Tomorrow</div>
          </div>
          <div className="nav-links">
            <button className="nav-link" onClick={()=>goTo("hero")}>Home</button>
            <button className="nav-link" onClick={()=>goTo("mission")}>Our Mission</button>
            <div className="nav-drop">
              <button className="nav-link">Programs ▾</button>
              <div className="nav-drop-menu">
                <button className="nav-drop-item" onClick={()=>goTo("awareness")}>Public Awareness</button>
                <button className="nav-drop-item" onClick={()=>goTo("coaching")}>Coaching Programs</button>
                <button className="nav-drop-item" onClick={()=>goTo("assessment")}>AI Assessment</button>
              </div>
            </div>
            <button className="nav-link" onClick={()=>goTo("blog")}>Insights</button>
            <button className="nav-link" onClick={()=>goTo("newsletter")}>Newsletter</button>
            <button className="nav-link" onClick={()=>goTo("footer")}>Contact</button>
          </div>
          <div className="nav-cta">
            <button className="btn btn-outline btn-sm" onClick={()=>goTo("coaching")}>Join a Program</button>
            <button className="btn btn-primary btn-sm" onClick={()=>window.open(ASSESSMENT_URL,"_blank")}>Start Assessment</button>
          </div>
          <button className={`hamburger${menuOpen?" open":""}`} onClick={toggleMenu} aria-label="Menu"><span/><span/><span/></button>
        </div>
      </nav>

      {/* MOBILE MENU */}
      <div className={`mob-menu${menuOpen?" open":""}`}>
        <div className="mob-section">Navigate</div>
        <button className="mob-link" onClick={()=>goTo("hero")}>Home</button>
        <button className="mob-link" onClick={()=>goTo("mission")}>Our Mission</button>
        <button className="mob-link" onClick={()=>goTo("awareness")}>Public Awareness</button>
        <div className="mob-section">Programs</div>
        <button className="mob-link" onClick={()=>goTo("coaching")}>Coaching Programs</button>
        <button className="mob-link" onClick={()=>goTo("assessment")}>AI Assessment</button>
        <div className="mob-section">Resources</div>
        <button className="mob-link" onClick={()=>goTo("blog")}>Blog & Insights</button>
        <button className="mob-link" onClick={()=>goTo("newsletter")}>Newsletter</button>
        <button className="mob-link" onClick={()=>goTo("footer")}>Contact</button>
        <div className="mob-ctas">
          <button className="btn btn-primary btn-lg" onClick={()=>goTo("coaching")}>Join a Program</button>
          <button className="btn btn-gold btn-lg" onClick={()=>window.open(ASSESSMENT_URL,"_blank")}>Start AI Assessment</button>
        </div>
      </div>

      {/* HERO */}
      <section className="hero" id="hero">
        <div className="hero-bg"/><div className="hero-grid"/>
        <div className="hero-content">
          <div>
            <div className="hero-pill"><span className="hero-dot"/>Responsible AI for Society</div>
            <h1 className="hero-h1"><em>Mentors</em> of<br/>Tomorrow</h1>
            <div className="hero-mission">Building Responsible AI for Society</div>
            <p className="hero-sub">We mentor every generation — young and old — to understand, shape, and use AI responsibly for the benefit of all of society. From enterprise leaders to curious students, Mentrum bridges the gap between AI's power and the people it serves.</p>
            <div className="hero-actions">
              <button className="btn btn-primary btn-lg" onClick={()=>goTo("coaching")}>Explore Programs</button>
              <button className="btn btn-outline btn-lg" onClick={()=>window.open(ASSESSMENT_URL,"_blank")}>Start AI Assessment</button>
            </div>
          </div>
          <div className="hero-right">
            {[
              { icon:"🌱", title:"Young Generation",      text:"Equipping students and early-career professionals with AI literacy and ethical frameworks.",              accent:"linear-gradient(90deg,#2563eb,#06b6d4)" },
              { icon:"🌿", title:"Experienced Leaders",   text:"Helping seasoned professionals stay relevant, informed, and empowered in an AI-shaped world.",          accent:"linear-gradient(90deg,#f59e0b,#f97316)" },
              { icon:"🤝", title:"Responsible AI",        text:"Ensuring AI development is ethical, inclusive, and guided by human values across all sectors.",          accent:"linear-gradient(90deg,#10b981,#06b6d4)" },
            ].map(c=>(
              <div key={c.title} className="hero-card">
                <div className="hero-card-accent" style={{background:c.accent}}/>
                <div className="hero-card-icon">{c.icon}</div>
                <div className="hero-card-title">{c.title}</div>
                <div className="hero-card-text">{c.text}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="hero-scroll"><span>Scroll</span><div className="scroll-line"/></div>
      </section>

      {/* MISSION */}
      <section className="mission-band" id="mission">
        <div className="mission-inner">
          <div>
            <div className="section-tag gold">Our Mission</div>
            <div className="mission-quote">"To mentor every generation in building AI that is responsible, inclusive, and beneficial for all of society."</div>
            <div className="mission-attr">— Mentrum.ai · Mentors of Tomorrow</div>
            <p style={{fontSize:".95rem",lineHeight:1.78,color:"var(--muted)",fontWeight:300,marginTop:"1.5rem",maxWidth:480}}>Mentrum.ai was founded on a simple belief: the benefits of artificial intelligence should be understood, accessible, and responsibly shaped by all generations — not just technologists.</p>
          </div>
          <div className="mission-pillars">
            {[
              {icon:"📢",title:"Public Awareness",   text:"Making AI literacy accessible to society through content, events, and community programs."},
              {icon:"🎓",title:"Mentorship & Coaching",text:"Guiding individuals through structured programs that build real AI confidence and competence."},
              {icon:"⚖️",title:"Responsible AI",      text:"Championing ethics, fairness, and human-centered design in every AI application."},
              {icon:"🌍",title:"Societal Impact",     text:"Ensuring AI serves communities, not just corporations — for current and future generations."},
            ].map(p=>(
              <div key={p.title} className="mission-pillar">
                <div className="mission-pillar-icon">{p.icon}</div>
                <div className="mission-pillar-title">{p.title}</div>
                <div className="mission-pillar-text">{p.text}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TWO PILLARS */}
      <section className="pillars-section" id="awareness">
        <div className="container">
          <div className="pillars-header">
            <div className="section-tag" style={{justifyContent:"center"}}>Two Pillars</div>
            <h2 className="section-h" style={{textAlign:"center"}}>How We Create Impact</h2>
            <p className="section-p" style={{textAlign:"center",margin:"0 auto"}}>Everything Mentrum does flows through two interconnected pillars — broad public awareness and deep individual coaching.</p>
          </div>
        </div>
        <div className="pillars-grid">
          <div className="pillar-panel awareness">
            <div className="pillar-num">01</div>
            <div className="section-tag">Pillar One</div>
            <h2 className="section-h">Public<br/>Awareness</h2>
            <p className="section-p">Reaching society broadly — making responsible AI knowledge accessible to everyone, regardless of technical background, age, or experience.</p>
            <div style={{marginTop:"2rem"}}>
              <button className="btn btn-primary" onClick={()=>goTo("blog")}>Read Our Insights →</button>
            </div>
            <div className="pillar-items">
              {[
                {t:"Weekly AI Digest",         p:"Plain-language newsletter covering AI's societal impact, ethics, and opportunities — for everyone."},
                {t:"Blog & Research",           p:"In-depth articles on responsible AI, policy, bias, and emerging trends written for broad audiences."},
                {t:"Speaking & Events",         p:"Community talks, school programs, webinars, and conference keynotes building AI literacy at scale."},
                {t:"Video & Social Content",    p:"Short-form explainers, podcasts, and social content making AI concepts approachable and engaging."},
              ].map(i=>(
                <div key={i.t} className="pillar-item">
                  <div className="pillar-item-title">{i.t}</div>
                  <div className="pillar-item-text">{i.p}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="pillar-panel coaching" id="coaching">
            <div className="pillar-num">02</div>
            <div className="section-tag green">Pillar Two</div>
            <h2 className="section-h">Mentorship &amp;<br/>Coaching</h2>
            <p className="section-p">Going deep with individuals and organizations — creating the lasting capability and confidence to navigate an AI-driven world responsibly.</p>
            <div style={{marginTop:"2rem"}}>
              <button className="btn btn-green" onClick={()=>goTo("programs")}>Explore Programs →</button>
            </div>
            <div className="pillar-items">
              {[
                {t:"Young AI Leaders",          p:"8-week cohort program for students and early-career professionals — free and subsidized."},
                {t:"AI Foundations for Life",   p:"Accessible program for experienced professionals and retirees navigating the AI era."},
                {t:"Executive AI Readiness",    p:"Intensive 1:1 coaching for C-suite leaders building responsible AI strategy."},
                {t:"AI Career Pivot",           p:"12-week reskilling program for mid-career professionals moving into AI-adjacent roles."},
              ].map(i=>(
                <div key={i.t} className="pillar-item">
                  <div className="pillar-item-title">{i.t}</div>
                  <div className="pillar-item-text">{i.p}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* WHO WE SERVE */}
      <section className="audience-section" id="audiences">
        <div className="container">
          <div className="section-tag" style={{justifyContent:"center"}}>Who We Serve</div>
          <h2 className="section-h" style={{textAlign:"center",marginBottom:".5rem"}}>Every Generation. Every Background.</h2>
          <p className="section-p" style={{textAlign:"center",margin:"0 auto"}}>Responsible AI education is not one-size-fits-all. We tailor our approach to meet people where they are.</p>
          <div className="audience-grid">
            <div className="aud-card young">
              <div className="aud-icon">🌱</div>
              <div className="aud-tag young">Young Generation · Ages 16–25</div>
              <div className="aud-title">Students &amp; Early Career</div>
              <div className="aud-text">The generation inheriting an AI-shaped world deserves more than STEM classes. We equip young people with critical thinking, ethical frameworks, and practical AI skills to become responsible builders of tomorrow.</div>
              <div className="aud-features">
                {["AI Literacy Bootcamps","Ethics & Critical Thinking","Career Pathways in AI","Mentorship Pairing with Industry Leaders"].map(f=><div key={f} className="aud-feature young">{f}</div>)}
              </div>
            </div>
            <div className="aud-card exec">
              <div className="aud-icon">🌿</div>
              <div className="aud-tag exec">Professionals & Leaders · 35+</div>
              <div className="aud-title">Experienced Professionals</div>
              <div className="aud-text">Career professionals and executives who need to lead AI initiatives, govern AI systems, or simply stay relevant in a rapidly changing landscape — without needing to become engineers.</div>
              <div className="aud-features">
                {["Executive AI Strategy Coaching","AI Governance Frameworks","Responsible Deployment Guidance","Board-Level AI Briefings"].map(f=><div key={f} className="aud-feature exec">{f}</div>)}
              </div>
            </div>
            <div className="aud-card society">
              <div className="aud-icon">🌍</div>
              <div className="aud-tag society">Community & Society · All Ages</div>
              <div className="aud-title">Communities &amp; Organizations</div>
              <div className="aud-text">Schools, nonprofits, community groups, and civic organizations that want to understand AI's impact on their communities and prepare their people for an AI-driven future — responsibly.</div>
              <div className="aud-features">
                {["Community AI Workshops","School Curriculum Partnerships","Nonprofit AI Readiness","Public Policy Awareness Programs"].map(f=><div key={f} className="aud-feature society">{f}</div>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ASSESSMENT */}
      <section className="assessment-section" id="assessment">
        <div className="assessment-inner">
          <div>
            <div className="assessment-badge">⭐ AI Readiness Tool</div>
            <h2 className="assessment-h">AI Maturity Assessment</h2>
            <p className="assessment-p">Understand exactly where your organization stands on the AI readiness spectrum — and get a clear, prioritized roadmap to close the gaps. Our proprietary 40-point framework evaluates people, process, data, and technology across five maturity levels.</p>
            <div className="assessment-steps">
              {[["01","Complete the Assessment","Answer 40 calibrated questions across four dimensions in under 20 minutes."],["02","Receive Your Score","Get an instant maturity score with dimension-level breakdowns and benchmarks."],["03","Get Your Roadmap","Receive a prioritized action plan with quick wins and strategic initiatives."]].map(([n,t,d])=>(
                <div key={n} className="assessment-step">
                  <div className="step-num">{n}</div>
                  <div className="step-body"><span className="step-title">{t}</span>{d}</div>
                </div>
              ))}
            </div>
            <button className="btn btn-gold btn-lg" onClick={()=>window.open(ASSESSMENT_URL,"_blank")}>Start Your Free Assessment →</button>
          </div>
          <div className="assess-visual" ref={assessRef}>
            <div className="assess-glow"/>
            <div className="assess-score-lbl">Sample Maturity Score</div>
            <div className="assess-score-num">72</div>
            <div className="assess-score-sub">out of 100 — Scaling Stage</div>
            <div className="assess-bars">
              {ASSESS_DIMS.map(d=>(
                <div key={d.label} className="assess-bar-row">
                  <div className="assess-bar-lbl"><span>{d.label}</span><span>{d.val}/100</span></div>
                  <div className="assess-bar-track"><div className="assess-bar-fill" style={{width:barsVisible?`${d.val}%`:"0%"}}/></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* PROGRAMS */}
      <section className="programs-section" id="programs">
        <div className="container">
          <div className="section-tag green">Coaching Programs</div>
          <h2 className="section-h">Programs for Every Stage</h2>
          <p className="section-p">Structured, human-centered learning experiences designed for where you are — and where you want to go.</p>
          <div className="programs-grid">
            {PROGRAMS.map(p=>(
              <div key={p.title} className={`prog-card ${p.cls}`}>
                <span className={`prog-badge ${p.badge}`}>{p.dur}</span>
                <div className="prog-icon">{p.icon}</div>
                <div className="prog-title">{p.title}</div>
                <div className="prog-audience">{p.audience}</div>
                <div className="prog-text">{p.text}</div>
                <div className="prog-details">
                  <div className="prog-detail"><strong>Format</strong><span>{p.format}</span></div>
                  <div className="prog-detail"><strong>Size</strong><span>{p.size}</span></div>
                  <div className="prog-detail"><strong>Investment</strong><span>{p.price}</span></div>
                </div>
              </div>
            ))}
          </div>
          <div style={{textAlign:"center",marginTop:"3rem"}}>
            <button className="btn btn-primary btn-lg" onClick={()=>goTo("newsletter")}>Get Notified When Programs Open →</button>
          </div>
        </div>
      </section>

      {/* BLOG */}
      <section className="blog-section" id="blog">
        <div className="container">
          <div className="blog-header">
            <div>
              <div className="section-tag">Insights</div>
              <h2 className="section-h">Blog &amp; Research</h2>
            </div>
            <a href="https://mentrum.ai/ai-blogs/" target="_blank" rel="noopener noreferrer" className="btn btn-outline">View All Posts →</a>
          </div>
          <div className="blog-grid">
            {BLOGS.map(post=>(
              <article key={post.id} className="blog-card" onClick={()=>setActivePost(post)}>
                <div className="blog-card-img" style={{background:post.bg}}>
                  <span style={{opacity:.35,fontSize:"3rem"}}>{post.emoji}</span>
                  <span className={`blog-card-cat ${post.catClass}`}>{post.cat}</span>
                </div>
                <div className="blog-card-body">
                  <div className="blog-card-meta">{post.date} · {post.rt} read</div>
                  <div className="blog-card-title">{post.title}</div>
                  <div className="blog-card-excerpt">{post.excerpt}</div>
                </div>
                <div className="blog-card-footer">
                  <span className="blog-read">Read Article →</span>
                  <span className="blog-rt">{post.rt}</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* NEWSLETTER */}
      <section className="nl-section" id="newsletter">
        <div className="nl-inner">
          <div>
            <div className="section-tag">Stay Informed</div>
            <h2 className="section-h">The Mentrum<br/>AI Digest</h2>
            <p className="section-p" style={{marginTop:"1rem"}}>Responsible AI insights for every generation — delivered weekly. No jargon. No vendor pitches. Just clear, human-centered thinking about AI and society.</p>
            <div className="nl-perks">
              {["Plain-language AI news anyone can understand","Ethical AI case studies and real-world examples","Program announcements and early access","Community spotlights and mentorship stories"].map(p=>(
                <div key={p} className="nl-perk"><div className="nl-dot"/>{p}</div>
              ))}
            </div>
          </div>
          <div>
            <div className="nl-form-title">Subscribe to the Digest</div>
            <div className="nl-form">
              <input className="nl-input" placeholder="First name" value={nlName} onChange={e=>setNlName(e.target.value)}/>
              <input className="nl-input" placeholder="Email address" type="email" value={nlEmail} onChange={e=>setNlEmail(e.target.value)}/>
              <select className="nl-select" value={nlFreq} onChange={e=>setNlFreq(e.target.value)}>
                <option value="weekly">Weekly digest</option>
                <option value="biweekly">Bi-weekly digest</option>
                <option value="monthly">Monthly roundup</option>
              </select>
              <button className="btn btn-primary btn-lg" onClick={subscribe}>Subscribe — It's Free</button>
              <p className="nl-disc">No spam. Unsubscribe anytime. For every generation.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="site-footer" id="footer">
        <div className="footer-inner">
          <div className="footer-grid">
            <div>
              <div className="footer-logo">mentrum<span>.</span>ai</div>
              <div className="footer-mission">Mentors of Tomorrow · Responsible AI for Society</div>
              <p className="footer-tagline">We mentor every generation — young and old — to understand, shape, and use AI responsibly for the benefit of all of society.</p>
            </div>
            <div>
              <div className="footer-col-title">Programs</div>
              <div className="footer-links">
                <button className="footer-link" onClick={()=>goTo("awareness")}>Public Awareness</button>
                <button className="footer-link" onClick={()=>goTo("coaching")}>Coaching Programs</button>
                <button className="footer-link" onClick={()=>goTo("programs")}>All Programs</button>
                <button className="footer-link" onClick={()=>window.open(ASSESSMENT_URL,"_blank")}>AI Assessment</button>
              </div>
            </div>
            <div>
              <div className="footer-col-title">Who We Serve</div>
              <div className="footer-links">
                <button className="footer-link" onClick={()=>goTo("audiences")}>Young Generation</button>
                <button className="footer-link" onClick={()=>goTo("audiences")}>Experienced Professionals</button>
                <button className="footer-link" onClick={()=>goTo("audiences")}>Communities & Orgs</button>
                <button className="footer-link" onClick={()=>goTo("audiences")}>Enterprise Leaders</button>
              </div>
            </div>
            <div>
              <div className="footer-col-title">Company</div>
              <div className="footer-links">
                <button className="footer-link" onClick={()=>goTo("mission")}>Our Mission</button>
                <button className="footer-link" onClick={()=>goTo("blog")}>Blog & Insights</button>
                <button className="footer-link" onClick={()=>goTo("newsletter")}>Newsletter</button>
                <a href="https://mentrum.ai/contact-us/" target="_blank" rel="noopener noreferrer" className="footer-link">Contact Us</a>
                <a href="https://mentrum.ai/terms-conditions/" target="_blank" rel="noopener noreferrer" className="footer-link">Terms & Conditions</a>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p className="footer-copy">© {new Date().getFullYear()} Mentrum AI · Mentors of Tomorrow · Responsible AI for Society</p>
            <div className="footer-socials">
              <button className="footer-social">LinkedIn</button>
              <button className="footer-social">Twitter</button>
              <button className="footer-social">YouTube</button>
            </div>
          </div>
        </div>
      </footer>

      {/* POST MODAL */}
      {activePost&&(
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setActivePost(null)}>
          <div className="modal-box">
            <div className="modal-img" style={{background:activePost.bg}}>
              <span style={{opacity:.35}}>{activePost.emoji}</span>
              <span className={`modal-badge ${activePost.catClass}`}>{activePost.cat}</span>
              <button className="modal-close-x" onClick={()=>setActivePost(null)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="modal-meta">{activePost.date} · {activePost.rt} read</div>
              <div className="modal-title">{activePost.title}</div>
              <div className="modal-content" dangerouslySetInnerHTML={{__html:activePost.body}}/>
            </div>
            <div className="modal-footer">
              <a href={activePost.url} target="_blank" rel="noopener noreferrer" className="btn btn-outline" style={{fontSize:".82rem"}}>View on mentrum.ai →</a>
              <button className="btn btn-primary" onClick={()=>setActivePost(null)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {toast&&<div className="toast show" style={{background:toast?.err?"#dc2626":"var(--blue)"}}>{toast?.msg}</div>}
    </>
  );
}
